import { httpClient } from "../http/httpClient";

type Bank = {
  value: string;
  label: string;
};

export interface banksResponse {
  banks: Bank[];
}
export interface banksParams {
  allBanks?: string;
  type?: string;
}
export const banks = async (params?: banksParams) => {
  const { data } = await httpClient.get<banksResponse>("/transaction/banks", {
    params,
  });

  return data;
};
